import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import Timeline from '@mui/lab/Timeline';
import {
    usePropertyProgress,
    usePropertySaving,
} from '../../../contextsProperty/ContextProperties';
import StepCard from './steps/StepCard';
import {
    URL_INVENTORY_LIST,
    URL_MAIN_INFO,
    URL_PUBLIC_PORTRAIT,
    URL_TAB_PARAM,
} from '../../../../utils/property/propertyUtils';
import TimelineStep from './steps/TimeLineStep';
import { PROGRESS_STEP } from '../../../../types/properties/propertyTypes';
import Title from '../Title';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';

const StepPropertyPresentation = () => {
    const history = useHistory();
    const path = history.location.pathname;

    const { progressByStep } = usePropertyProgress();
    const { handleSaveFinish } = usePropertySaving();

    const activeStep = useMemo(() => {
        if (progressByStep.room_configuration.percent === 100) {
            return 'send';
        }
        if (progressByStep.description.percent === 100) {
            return PROGRESS_STEP.ROOM_CONFIGURATION;
        }

        if (progressByStep.main_info.percent === 100) {
            return PROGRESS_STEP.PUBLIC_PORTRAIT;
        }
        return PROGRESS_STEP.MAIN_INFORMATION;
    }, [progressByStep]);

    return (
        <section className='flex-column gap-36 margin-block50'>
            <Title
                text='welcome_to_your_property'
                className='text-align-center'
            />
            <main className=''>
                <Timeline position='right'>
                    <TimelineStep
                        iconName={commonIcons.HOTEL}
                        completed={progressByStep.main_info.percent === 100}
                        active={activeStep === PROGRESS_STEP.MAIN_INFORMATION}
                    >
                        <StepCard
                            title='main_info'
                            description='main_info_description'
                            progress={progressByStep.main_info.percent}
                            onButtonClick={() => {
                                history.push(
                                    `${path}${URL_MAIN_INFO}${URL_TAB_PARAM(1)}`
                                );
                            }}
                            isButtonDisabled={false}
                        />
                    </TimelineStep>
                    <TimelineStep
                        iconName={commonIcons.MEAL_PLAN}
                        completed={progressByStep.description.percent === 100}
                        active={activeStep === PROGRESS_STEP.PUBLIC_PORTRAIT}
                    >
                        <StepCard
                            title='description'
                            description='description_section_description'
                            progress={progressByStep.description.percent}
                            onButtonClick={() => {
                                history.push(
                                    `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                        1
                                    )}`
                                );
                            }}
                            isButtonDisabled={
                                progressByStep.main_info.percent !== 100
                            }
                        />
                    </TimelineStep>
                    <TimelineStep
                        iconName={commonIcons.ROOM}
                        completed={
                            progressByStep.room_configuration.percent === 100
                        }
                        active={activeStep === PROGRESS_STEP.ROOM_CONFIGURATION}
                    >
                        <StepCard
                            title='room_configuration'
                            description='room_configuration__description'
                            progress={progressByStep.room_configuration.percent}
                            onButtonClick={() => {
                                history.push(`${path}${URL_INVENTORY_LIST}`);
                            }}
                            isButtonDisabled={
                                progressByStep.description.percent !== 100
                            }
                        />
                    </TimelineStep>
                    <TimelineStep
                        iconName='Send'
                        last
                        active={activeStep === 'send'}
                    >
                        <StepCard
                            title='finish_proccess'
                            description='finish_proccess__description'
                            onButtonClick={handleSaveFinish}
                            isButtonDisabled={
                                progressByStep.room_configuration.percent !==
                                100
                            }
                            buttonText='finish'
                        />
                    </TimelineStep>
                </Timeline>
            </main>
        </section>
    );
};

export default StepPropertyPresentation;
